import { render, staticRenderFns } from "./AppMobileNavigation.vue?vue&type=template&id=2ff8be08&"
import script from "./AppMobileNavigation.vue?vue&type=script&lang=js&"
export * from "./AppMobileNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppMobileNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports